import { Swagpack } from "../models/Swagstore/Packs";
import { OrderMockup } from "../models/Order/OrderMockup";

/**
 * Gets the display image for a pack based on priority:
 * 1. pack_image_url (if exists)
 * 2. Mockups: priority === 1, or first mockup if no priority 1
 * 3. Product images: is_default === 1, or first image if no default
 * 4. Fallback to default placeholder
 */
export const getPackDisplayImage = (
    pack: Swagpack,
    fallbackImage?: string
): string => {

    const defaultPlaceholder =
        fallbackImage ||
        "https://content.swageazy.com/blogs/Vector-(1)_1742630924118.png";

    // Priority 1: Check pack_image_url
    if (pack.pack_image_url) {
        return pack.pack_image_url;
    }

    // Priority 2: Check mockups from first product
    const firstProduct = pack.products?.[0];
    if (firstProduct?.mockups && firstProduct.mockups.length > 0) {
        // Find mockup with priority === 1
        const priorityMockup = firstProduct.mockups.find(
            (mockup: OrderMockup) => mockup.priority === 1
        );

        if (priorityMockup?.image_url) {
            return priorityMockup.image_url;
        }

        // If no priority 1, use first mockup
        if (firstProduct.mockups[0]?.image_url) {
            return firstProduct.mockups[0].image_url;
        }
    }

    // Priority 3: Check product images
    if (firstProduct?.images && firstProduct.images.length > 0) {
        // Check if images is an array of objects with is_default property
        const firstImage = firstProduct.images[0];

        // If images is ProductImage[] with is_default property (object array)
        if (typeof firstImage === "object" && firstImage !== null && !Array.isArray(firstImage)) {
            // Find image with is_default === 1 (or true)
            const defaultImage = firstProduct.images.find(
                (img: any) =>
                    (img.is_default === 1 || img.is_default === true) &&
                    (img.url || img.image_url || img.img)
            ) as any;

            if (defaultImage) {
                return defaultImage.url || defaultImage.image_url || defaultImage.img || "";
            }

            // If no default, use first image
            const firstImg = firstProduct.images[0] as any;
            return firstImg.url || firstImg.image_url || firstImg.img || "";
        }

        // If images is string[], use the first image
        if (typeof firstImage === "string") {
            return firstImage;
        }
    }

    return defaultPlaceholder;
};

